/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AprilFoolType,
    AprilFoolTypeFromJSON,
    AprilFoolTypeFromJSONTyped,
    AprilFoolTypeToJSON,
} from './AprilFoolType';
import {
    PressRelease,
    PressReleaseFromJSON,
    PressReleaseFromJSONTyped,
    PressReleaseToJSON,
} from './PressRelease';
import {
    SearchedPressReleaseAllOf,
    SearchedPressReleaseAllOfFromJSON,
    SearchedPressReleaseAllOfFromJSONTyped,
    SearchedPressReleaseAllOfToJSON,
} from './SearchedPressReleaseAllOf';

/**
 * 
 * @export
 * @interface SearchedPressRelease
 */
export interface SearchedPressRelease {
    /**
     * プレスリリースID
     * @type {number}
     * @memberof SearchedPressRelease
     */
    pressReleaseId: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof SearchedPressRelease
     */
    companyId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof SearchedPressRelease
     */
    title: string;
    /**
     * 企業名
     * @type {string}
     * @memberof SearchedPressRelease
     */
    companyName: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof SearchedPressRelease
     */
    publishedDatetime: string;
    /**
     * 
     * @type {string}
     * @memberof SearchedPressRelease
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SearchedPressRelease
     */
    pressReleaseUrl: string;
    /**
     * 
     * @type {AprilFoolType}
     * @memberof SearchedPressRelease
     */
    aprilFoolType: AprilFoolType;
    /**
     * 保存済みかどうかを表すフラグ
     * @type {boolean}
     * @memberof SearchedPressRelease
     */
    isBookmarked: boolean;
    /**
     * 検索文字にヒットした前後の文章
     * @type {string}
     * @memberof SearchedPressRelease
     */
    snippet: string;
}

export function SearchedPressReleaseFromJSON(json: any): SearchedPressRelease {
    return SearchedPressReleaseFromJSONTyped(json, false);
}

export function SearchedPressReleaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedPressRelease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleaseId': json['press_release_id'],
        'companyId': json['company_id'],
        'title': json['title'],
        'companyName': json['company_name'],
        'publishedDatetime': json['published_datetime'],
        'thumbnailUrl': json['thumbnail_url'],
        'pressReleaseUrl': json['press_release_url'],
        'aprilFoolType': AprilFoolTypeFromJSON(json['april_fool_type']),
        'isBookmarked': json['is_bookmarked'],
        'snippet': json['snippet'],
    };
}

export function SearchedPressReleaseToJSON(value?: SearchedPressRelease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release_id': value.pressReleaseId,
        'company_id': value.companyId,
        'title': value.title,
        'company_name': value.companyName,
        'published_datetime': value.publishedDatetime,
        'thumbnail_url': value.thumbnailUrl,
        'press_release_url': value.pressReleaseUrl,
        'april_fool_type': AprilFoolTypeToJSON(value.aprilFoolType),
        'is_bookmarked': value.isBookmarked,
        'snippet': value.snippet,
    };
}

